import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

/**
 * Componente de DatePicker
 * @param {string} placeholder - Placeholder do datepicker
 * @param {string|Date} value - Valor da data
 * @param {function} onChange - Função de mudança
 * @param {string} format - Formato da data (DD/MM/YYYY)
 * @param {boolean} disabled - Se o datepicker está desabilitado
 * @param {string} size - Tamanho do datepicker (large, middle, small)
 * @param {boolean} showTime - Se deve mostrar seleção de hora
 */
const DateComponent = ({ 
  placeholder = 'Selecione a data', 
  value = null, 
  onChange = () => {}, 
  format = 'DD/MM/YYYY',
  disabled = false,
  size = 'middle',
  showTime = false,
  ...props 
}) => {
  const dateValue = value ? dayjs(value) : null;

  const handleChange = (date, dateString) => {
    onChange(date ? date.format('YYYY-MM-DD') : null);
  };

  return (
    <DatePicker
      placeholder={placeholder}
      value={dateValue}
      onChange={handleChange}
      format={format}
      disabled={disabled}
      size={size}
      showTime={showTime}
      style={{ width: '100%' }}
      {...props}
    />
  );
};

export default DateComponent;



